export const GET_ALL_PRICE_REQUEST = "GET_CUSTOMERS_REQUEST";
export const GET_ALL_PRICE_FAILURE = "GET_CUSTOMERS_FAILURE";
export const GET_ALL_PRICE_SUCCESS = "GET_CUSTOMERS_SUCCESS";

export const CREATE_PRICE_REQUEST = "GET_CUSTOMERS_REQUEST";
export const CREATE_PRICE_FAILURE = "GET_CUSTOMERS_FAILURE";
export const CREATE_PRICE_SUCCESS = "GET_CUSTOMERS_SUCCESS";

export const UPDATE_PRICE_REQUEST = "GET_CUSTOMERS_REQUEST";
export const UPDATE_PRICE_FAILURE = "GET_CUSTOMERS_FAILURE";
export const UPDATE_PRICE_SUCCESS = "GET_CUSTOMERS_SUCCESS";

export const DELETE_PRICE_REQUEST = "GET_CUSTOMERS_REQUEST";
export const DELETE_PRICE_FAILURE = "GET_CUSTOMERS_FAILURE";
export const DELETE_PRICE_SUCCESS = "GET_CUSTOMERS_SUCCESS";